export enum DatePickerFormats {
    MONTH_YEAR = "MM.yyyy",
    DEFAULT = "dd.MM.yyyy"
}

export enum DatePickerPlaceholders {
    MONTH_YEAR = "mm.yyyy",
    DEFAULT = "dd.mm.yyyy"
}

export enum DatePickerSize {
    SMALL = 'small',
    DEFAULT = 'default'
}